import React from 'react'
import { useValues } from 'kea'
import logic from '../logic'
import '../styles.scss'

export default function Faq () {
  const {
    faq: { body, title }
  } = useValues(logic)
  return (
    <div>
      <h2 className='similar-related page-title'>{title}</h2>
      <br />
      <div className='help-content' dangerouslySetInnerHTML={{ __html: body }} />
    </div>
  )
}
